import React, {useEffect, useState} from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import SignIn from './features/auth/SignIn'
import { useAppSelector, useAppDispatch } from './hooks/redux'
import Layout from './components/Layout'
import routes from './routes'
import {getCartFromLS} from "./helpers";
import {setCart} from "./features/cart/cartSlice";
import LeftSlide from "./components/LeftSlide/LeftSlide";
import { Helmet } from 'react-helmet';
import { useVisitTracker } from "./hooks/useVisitTracker";
import { useTranslation } from 'react-i18next';

const App = () => {
    const dispatch = useAppDispatch()
    const { t } = useTranslation()
    const slogan = t('general.specialized_online_store') ?? ''

    // Счётчик посетителей (визит > 5 сек, дедуп по дню, исключая dev-режим)
    useVisitTracker()

    useEffect(() => {
        const cart = getCartFromLS()
        if(cart?.products.length){
            dispatch(setCart(cart))
        }
    }, [])

    // Защита контента: блок контекстного меню (правый клик → «Сохранить картинку»)
    // и перетаскивания изображений. Выделение текста запрещено через CSS (index.css).
    // Примечание: это защита от обычного пользователя, не абсолютная.
    useEffect(() => {
        const prevent = (e: Event) => e.preventDefault()
        document.addEventListener('contextmenu', prevent)
        document.addEventListener('dragstart', prevent)
        return () => {
            document.removeEventListener('contextmenu', prevent)
            document.removeEventListener('dragstart', prevent)
        }
    }, [])

    return (
        <div className="app">
            <Helmet>
                <title>{`Svecha.am — ${slogan}`}</title>
                <meta name="description" content={slogan} />
                <meta property="og:title" content={`Svecha.am — ${slogan}`} />
                <meta property="og:description" content={slogan} />
                <meta property="og:image" content="https://svecha.am/og-image.jpg" />
                <meta property="og:url" content={'https://www.svecha.am'} />
            </Helmet>
            <LeftSlide />
            <Routes>
                <Route path="/" element={<Layout />}>
                    {routes.privateRoutes.map((route) => (
                        <Route
                            key={route.path}
                            path={route.path}
                            element={<route.element />}
                        />
                    ))}
                </Route>
                <Route path="*" element={<Navigate to="/" />}></Route>
            </Routes>
        </div>
    )
}

export default App
